import { Box, Divider, Stack, Typography } from '@mui/material';
import section3_image1 from 'assets/img/ECommerce/section3_image1.png';
import section3_image2 from 'assets/img/ECommerce/section3_image2.png';
import section3_logo1 from 'assets/img/ECommerce/section3_logo1.png';
import React, { JSX } from 'react';
import { IoStarSharp } from 'react-icons/io5';
import { E_COMMERCE_STYLES } from './config';

export default function Section3(): JSX.Element {
  return (
    <>
      <Box sx={{ px: 2, py: 4 }}>
        <Stack maxWidth={E_COMMERCE_STYLES.container.maxWidth} mx={E_COMMERCE_STYLES.container.mx}>
          <Stack direction={'row'} mb={1}>
            {[1, 2, 3, 4, 5].map((num) => (
              <IoStarSharp key={num} color="#FFCC00" size={'35px'} />
            ))}
          </Stack>
          <Typography variant="h2" mb={4} className="font-helvetica-bold">
            Trusted by Visionary GCC Enterprises
          </Typography>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <Box component="img" mb={1} src={section3_image1} alt="trusted brands" />
            <Box
              component="img"
              mb={5}
              src={section3_logo1}
              sx={{ width: '150px' }}
              alt="trusted brands"
            />
            <Box component="img" src={section3_image2} alt="trusted brands" />
          </Stack>
        </Stack>
      </Box>
      <Box px={2.5} mt={4}>
        <Divider />
      </Box>
    </>
  );
}
